import api from 'services/api'
import {
  GET_TICKETS_LIST,
  CREATE_TICKET,
  GET_TICKET_DETAIL,
  UPDATE_TICKET,
  DELETE_TICKET,
  LIST_COMMENT,
  ADD_COMMENT
} from '../endpoints'

export const getTicketsList = async (body) => await api.post(GET_TICKETS_LIST, body)
export const deleteTicket = async (id) => await api.delete(DELETE_TICKET, {data: {brand_ad_id: id}})
export const getTicketDetail = async (id) => await api.get(`${GET_TICKET_DETAIL}?ticket_id=${id}`)
export const listComment= async (body) => await api.post(LIST_COMMENT,body)
export const submitComment= async (body) => await api.post(ADD_COMMENT,body);

export const submitTicket = async (values, id) =>
  await api.post(id ? UPDATE_TICKET : CREATE_TICKET, values, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
